import { render, staticRenderFns } from "./shopdecoration.vue?vue&type=template&id=43778763&scoped=true&"
import script from "./shopdecoration.vue?vue&type=script&lang=js&"
export * from "./shopdecoration.vue?vue&type=script&lang=js&"
import style0 from "./shopdecoration.vue?vue&type=style&index=0&id=43778763&scoped=true&lang=css&"
import style1 from "./shopdecoration.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43778763",
  null
  
)

export default component.exports